import React, { useEffect } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { getStatSearchFreq } from '../../../http/manager';
import "echarts-wordcloud";
import * as echarts from 'echarts';

const TextCloud: React.FC = () => { 
    useEffect(()=> {
        getData();
        return;
    }, [])
    const getData = ()=> {
        getStatSearchFreq({}).then((res:any)=> {
            let yData:any = [];
            res.data.forEach((element:any)=> {
                // element.itemStyle = {
                //     normal: {
                //         color: getColor()
                //     }
                // }
                element.textStyle = {
                    color: getColor()
                }
                yData.push(element)
            })
            let maskImage = new Image();
            maskImage.src= require('../../../image/text-cloud-bg.png');
            let myChart = echarts.init(document.getElementById('wordcloudl'));
            maskImage.onload = ()=> {
                myChart.setOption({
                    backgroundColor: "#fff",
                    tooltip: {
                        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                    },
                    series: [{
                        type: "wordCloud",
                        gridSize: 16,
                        sizeRange: [16, 24],
                        rotationRange: [0, 0],
                        maskImage: maskImage,
                        textPadding: 5,
                        left: "center",
                        top: "center",
                        right: null,
                        bottom: null,
                        width: "100%",
                        height: "110%",
                        data: yData
                    }]
                })
            }
        })
    }
    const getColor = ()=> {
        let colorList = [
            '#41ACFC',
            '#456BC5',
            '#7994D5',
            '#C6F1D5',
            "#6381CD",
            "#9AE3E9"
        ];
        let num = Math.floor(Math.random()*6);
        return colorList[num]
    }
    return (
        <CloudContainer>
            <div id='wordcloudl' style={{ width: '100%', height: '100%' }}></div>
        </CloudContainer>
    )
}

export default observer(TextCloud);

const CloudContainer = styled.div`
     & {
        width: 100%;
        height: 100%;
    }
`